export default __webpack_public_path__ + "static/media/backspace-icon.755621a5.svg";